module.exports = __webpack_public_path__ + "static/media/NetherlandHighlyskilledMigrantVisa.67127759.mp4";